/**
 * 根据与 rotateKlass 一致的组旋转角度，判断逻辑边是否落在物理左右边。
 */
export function isPhysicalLeftOrRightEdge(
  positionName,
  { rotateDeg, xyReverse = false, rotatePlank = false } = {}
) {
  const groupAngle = getTypographyGroupAngle({
    rotateDeg,
    xyReverse,
    rotatePlank,
  })
  const isQuarterTurn = Math.abs(groupAngle % 180) === 90

  return isQuarterTurn
    ? ['BE', 'TE'].includes(positionName)
    : ['LE', 'RE'].includes(positionName)
}

/**
 * 将封边文字适配到阅读方向的预留宽度，不改变排版图形区域。
 * 保留 16px 基础字号，使 0.5 组缩放后的有效字号不低于 8px；
 * 仍超宽时只压缩文字本身。
 */
export function fitEdgeTextToWidth(text, maxWidth) {
  if (text.width > maxWidth) {
    text.set({
      fontSize: Math.max(16, text.fontSize * (maxWidth / text.width)),
    })
  }
  if (text.getScaledWidth() > maxWidth) {
    text.set({
      scaleX: text.scaleX * (maxWidth / text.getScaledWidth()),
    })
  }
}

function getTypographyGroupAngle({ rotateDeg, xyReverse, rotatePlank }) {
  if (Number.isFinite(rotateDeg)) {
    return normalizeAngle(rotateDeg - (xyReverse ? 90 : 0))
  }

  if (rotatePlank) {
    return xyReverse ? 180 : 270
  }

  return xyReverse ? 270 : 0
}

function normalizeAngle(angle) {
  return ((angle % 360) + 360) % 360
}
